<div class="service-inspection pointer w-100 flex-between-end h-100p"
  [ngClass]="{'overview-order-view': isFromOverview}" (click)="handleOpenInspection()">
  <div [ngClass]="isFromOverview ? 'width-100p' : 'width-95p'">
    <div class="service-inspection-left flex-start-center w-100">
      <i *ngIf="!isFromOverview" class="fal fa-ballot-check font-gray-45"></i>

      <div class="service-inspection-title flex-start-center w-100 font-12">
        <!-- <span class="font-600 m-0 ml-2 ellipsis inspection-name" tooltipPosition="top"
          [pTooltip]="_inspection.title">{{_inspection.title}}</span> -->
        <span class="font-600 m-0 ml-2 inspection-name" tooltipPosition="top"
          [pTooltip]="companyLocalization && currentLang === 'fr' && _inspection.titleFR? _inspection.titleFR:_inspection.title">{{companyLocalization
          && currentLang === 'fr' && _inspection.titleFR? _inspection.titleFR:_inspection.title}}</span>
        <span class="ml-1 mr-1">&#8213;</span>
        <span *ngIf="!isFromOverview" class="m-0 font-4c">{{categoryItemText}}</span> 
        <span 
            class="status-tag"
            *ngIf="isDvi2Enabled"
            [ngClass]="{
              'todo-tag': !_inspection?.inspectionStatus || _inspection.inspectionStatus === 'todo',
              'in-progress-tag': _inspection.inspectionStatus === 'inProgress',
              'completed-tag': _inspection.inspectionStatus === 'completed'
            }"
          >
            {{ 
              (!_inspection?.inspectionStatus || _inspection.inspectionStatus === 'todo') ? 'To Do' : 
              (_inspection.inspectionStatus === 'inProgress' ? 'In Progress' : 'Completed') 
            }}
          </span>
        <span *ngIf="isFromOverview && assignedTo" class="m-0 font-4c">{{isComplete ? 'Completed by' : 'Assigned to'}}
          <span [ngClass]="{'highlight': isOwnerTechnician}">{{ isOwnerTechnician ? 'You' : assignedTo }}</span></span>
        <span *ngIf="isFromOverview && !assignedTo" class="m-0 font-4c">Unassigned</span>
      </div>
    </div>

    <div class="service-inspection-right flex-start-center mt-2 ml-2">
      <!-- Not Inspection -->
      <div class="flex-start-center" tooltipPosition="top"
        pTooltip="{{counts?.condition?.notInspected}} / {{counts?.items}} are not filled">
        <div class="inspection-condition-circle item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.notInspected}}</p>
      </div>

      <!-- Bad Condition -->
      <div class="flex-start-center condition-counts" tooltipPosition="top"
        pTooltip="{{counts?.condition?.bad}} / {{counts?.items}} are marked Red">
        <div class="inspection-condition-circle bad item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.bad}}</p>
      </div>

      <!-- Normal Condition -->
      <div class="flex-start-center condition-counts" tooltipPosition="top"
        pTooltip="{{counts?.condition?.normal}} / {{counts?.items}} are marked Yellow">
        <div class="inspection-condition-circle normal item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.normal}}</p>
      </div>

      <!-- Good Condition -->
      <div class="flex-start-center condition-counts" tooltipPosition="top"
        pTooltip="{{counts?.condition?.good}} / {{counts?.items}} are marked Green">
        <div class="inspection-condition-circle good item-count-margin"></div>
        <p class="m-0 font-12">{{counts?.condition?.good}}</p>
      </div>

      <!-- Images Count -->
      <div *ngIf="addMediaToInspectionEnabled && !isFromOverview" class="flex-start-center condition-counts" tooltipPosition="top"
        pTooltip="{{counts?.images}} pictures are attached">
        <div class="item-count-margin">
          <i class="far fa-images font-gray-45"></i>
        </div>
        <p class="m-0 font-12">{{counts?.images}}</p>
      </div>

      <!-- Video Count -->
      <div *ngIf="addMediaToInspectionEnabled && !isFromOverview" class="flex-start-center condition-counts" tooltipPosition="top"
        pTooltip="{{counts?.videos}} videos are attached">
        <div class="item-count-margin">
          <i class="far fa-video font-gray-45"></i>
        </div>
        <p class="m-0">{{counts?.videos}}</p>
      </div>

      <!-- Audio Count -->
      <div *ngIf="addMediaToInspectionEnabled && !isFromOverview" class="flex-start-center condition-counts" tooltipPosition="top"
        pTooltip="{{counts?.audios}} audios are attached">
        <div class="item-count-margin">
          <i class="far fa-volume font-gray-45"></i>
        </div>
        <p class="m-0 font-12">{{counts?.audios}}</p>
      </div>
    </div>
  </div>

  <div *ngIf="!isFromOverview && !_inspection.associatedInspectionId" class="flex-around-center dlt-btn-wrapper">
    <div [ngClass]="{'disabled-estimate-field':isArchived || isLockedRO}">
      <div class="pointer" (click)="deleteInspection($event)">
        <i class="fas fa-trash font-gray-35"></i>
      </div>
    </div>
  </div>
</div>
